// extracted by mini-css-extract-plugin
export default {"rating":"Zv-z","numberOfStars":"_v-z","count":"aw-z","barGraphSpacing":"bw-z","barGraph":"cw-z"};